export default __webpack_public_path__ + "static/media/share.963c45eb.svg";